var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHandbag = function SvgIconHandbag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.356 5.75a4.75 4.75 0 0 1 9.288 0h2.93v1l.006-1a1.76 1.76 0 0 1 1.737 1.542l.002.013 1.33 11.998.001.002a1.75 1.75 0 0 1-1.728 1.945H3.078a1.75 1.75 0 0 1-1.728-1.946L2.682 7.291A1.76 1.76 0 0 1 4.42 5.75h2.936m2.7-.945a2.75 2.75 0 0 1 4.506.945H9.438c.137-.35.346-.673.617-.945M7.25 7.75v2a1 1 0 1 0 2 0v-2h5.5v2a1 1 0 1 0 2 0v-2h2.606l1.276 11.5H3.368l1.276-11.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHandbag;